<article
  class="ticket-card"
  [class.ticket-card-draggable]="draggable()"
  [attr.draggable]="draggable()"
  (dragstart)="onDragStart($event)"
  (dragend)="onDragEnd()"
  (click)="onClick()"
>
  <button
    type="button"
    class="ticket-card-open"
    [attr.aria-label]="'Ouvrir le ticket ' + ticket().reference"
    (click)="$event.stopPropagation(); onClick()"
  >
    Ouvrir le ticket {{ ticket().reference }}
  </button>
  <header class="ticket-card-header">
    <div class="ticket-card-identification">
      <div class="ticket-card-badges">
        @if (showSiteName()) {
          <span class="ticket-card-site" [title]="ticket().site ?? ''">
            <span class="material-symbols-outlined" aria-hidden="true">home</span>
            <span>{{ ticket().site }}</span>
          </span>
        }
        <span [class]="'ticket-card-ref ' + (ticket().referenceClass ?? '')">{{
          ticket().reference
        }}</span>
      </div>
      <p class="ticket-card-created">Créé le {{ dateCreation() }}</p>
    </div>
    <span
      class="ticket-card-loss"
      [class.ticket-card-default]="ticket().pertes === undefined"
      [class.ticket-card-loss-confirmed]="ticket().pertes === 'avérées'"
      [class.ticket-card-loss-none]="ticket().pertes === 'aucune'"
      [class.ticket-card-loss-undetermined]="ticket().pertes === 'indéterminées'"
      [title]="ticket().pertes === undefined ? indicationParDefaut : 'Pertes de production'"
    >
      Pertes : {{ ticket().pertes ?? 'possibles' }}
      @if (ticket().pertes === undefined) {
        <span class="visually-hidden"> — {{ indicationParDefaut }}</span>
      }
    </span>
  </header>

  <p
    class="ticket-card-issue"
    [attr.title]="ticket().issueTooltip ?? null"
    [innerHTML]="ticket().issue"
  ></p>

  @if (ticket().owner) {
    <p class="ticket-card-owner">
      <span class="material-symbols-outlined" aria-hidden="true">person</span>
      {{ ticket().owner }}
    </p>
  }

  <div class="ticket-card-meta">
    <div class="ticket-card-messages ticket-card-activity">
      <span class="ticket-card-icon-wrap">
        <span
          class="ticket-card-status-icon"
          [class.ticket-card-status-icon-new]="nouveauTicket()"
          [title]="ticket().vu ? 'Messages lus' : 'Messages non lus'"
          role="img"
          [attr.aria-label]="ticket().vu ? 'Messages lus' : 'Messages non lus'"
        >
          <span class="material-symbols-outlined" aria-hidden="true">mail</span>
        </span>
        @if (notificationMessage()) {
          <span
            class="ticket-card-notification ticket-card-message-unread"
            role="img"
            [attr.aria-label]="nouveauTicket() ? 'Nouveau ticket' : 'Messages non lus'"
            [title]="nouveauTicket() ? 'Nouveau ticket' : 'Messages non lus'"
          >
            <span class="material-symbols-outlined" aria-hidden="true">notifications</span>
          </span>
        }
      </span>
      <div class="ticket-card-activity-text">
        <span class="ticket-card-activity-label">Dernier message</span>
        @if (sansMessage()) {
          <span class="ticket-card-activity-empty">{{
            ticket().nbMessages === 0 ? 'Aucun message' : 'Aucun message daté'
          }}</span>
        } @else {
          <span
            class="ticket-card-activity-age ticket-card-message-age"
            [class.ticket-card-default]="!ancienneteMessage()"
            [title]="ancienneteMessage() ? 'Ancienneté du dernier message' : indicationParDefaut"
            >{{ ancienneteMessage() ?? 'Date indisponible' }}</span
          >
        }
      </div>
    </div>

    <div class="ticket-card-intervention ticket-card-activity">
      <span class="ticket-card-icon-wrap">
        <!-- La planification détermine la couleur de l’icône ; seul son libellé de date signale le retard. -->
        <app-intervention-acces
          [ticketId]="ticket().id ?? null"
          [installationId]="ticket().installationId ?? null"
          [afficherLibelle]="false"
          [style.--interventions-trigger-background]="dateIntervention() ? '#008574' : '#bc2545'"
          [infobulle]="statutIntervention()"
          [libelle]="'Interventions du ticket ' + ticket().reference"
        />
        @if (ticket().bonsInterventionNonLus) {
          <span
            class="ticket-card-notification ticket-card-intervention-unread"
            role="img"
            aria-label="Nouveaux bons d’intervention"
            title="Nouveaux bons d’intervention"
          >
            <span class="material-symbols-outlined" aria-hidden="true">notifications</span>
          </span>
        }
      </span>
      <div class="ticket-card-activity-text">
        @if (dateIntervention(); as date) {
          <time
            class="ticket-card-intervention-date"
            [attr.datetime]="ticket().dateInterventionPlanifiee"
            [class.ticket-card-date-overdue]="interventionDepassee()"
            [title]="statutIntervention()"
            [attr.aria-label]="statutIntervention()"
            >Intervention planifiée le {{ date }}</time
          >
        } @else {
          <span class="ticket-card-activity-label">Dernière intervention</span>
        }
        @if (!sansIntervention()) {
          <span
            class="ticket-card-activity-age ticket-card-intervention-age"
            [class.ticket-card-default]="!ancienneteIntervention()"
            [title]="
              ancienneteIntervention()
                ? 'Ancienneté de la dernière intervention réalisée'
                : indicationParDefaut
            "
            >{{ ancienneteIntervention() ?? 'Date indisponible' }}</span
          >
        } @else if (!dateIntervention()) {
          <span class="ticket-card-activity-empty">Aucune intervention</span>
        }
      </div>
    </div>
  </div>
</article>
